export default function Features() {
  const features = [
    {
      icon: 'ri-4k-line',
      title: '4K超清画质',
      description: '支持4K超高清分辨率播放，每一个画面细节都清晰可见，为您带来影院级观影体验。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速加载播放',
      description: '采用全球CDN加速节点，视频秒加载不卡顿，无论何时何地都能流畅观看。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端无缝切换',
      description: '支持手机、平板、电脑等多终端访问，观影记录云端同步，随时随地继续观看。',
    },
    {
      icon: 'ri-download-cloud-2-line',
      title: '无需下载安装',
      description: '纯网页在线播放，无需下载任何软件或插件，打开浏览器即可立即享受高清视频。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '绿色安全无毒',
      description: '平台经过多重安全检测，无弹窗广告、无恶意插件，为您提供纯净安全的观影环境。',
    },
    {
      icon: 'ri-global-line',
      title: '海量资源覆盖',
      description: '10万+高清视频资源库，涵盖电影、电视剧、综艺、动漫、纪录片、体育六大品类。',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">为什么选择久久在线观看</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">我们致力于为用户提供极致的在线视频观看体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, index) => (
            <div key={index} className="flex gap-4 p-5 rounded-xl bg-background-50">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 shrink-0">
                <i className={`${feat.icon} text-xl text-secondary-600`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1.5">{feat.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}